import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { RenderPageProps } from "./RenderPage";
const RenderPage = lazy(() => import("./RenderPage").then(module => ({ default: module.RenderPage })));

export function mountRenderPage(slot: HTMLElement, props: RenderPageProps) {
  setStudioView("stage", `render-page:${props.release.project.id}`, <RenderPage key={props.release.project.id} {...props} />);
}
